import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Dropdown,
} from "reactstrap";

export default ({
  closeParent,
  hide_link_infoserv_info,
  hide_link_infoserv_serv,
  hide_link_infoserv_faq,
  hide_link_infoserv_contact,
  all_in_one_tab,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Dropdown
      tag="span"
      nav
      style={{ display: "block" }}
      id="account_name_id"
      isOpen={isOpen}
      toggle={() => {
        setIsOpen(!isOpen);
        if (isOpen) closeParent();
      }}
    >
      <DropdownToggle
        tag="button"
        nav
        className="account_name"
        style={{
          display: "block",
          width: "100%",
          textAlign: "left",
          fontSize: "1.1em",
        }}
      >
        <i
          className="icon_c_m icon_c_bg icon_info"
          style={{ margin: "0 10px", color: "rgba(132, 132, 132, 0.5)" }}
        />
        <FormattedMessage id="header_info_infoAndServices" />
      </DropdownToggle>
      <DropdownMenu right style={{ margin: "0 60px 0 -40px" }}>
        {!hide_link_infoserv_info && (
          <Link to="/info/terms" target={all_in_one_tab ? "_self" : "_blank"}>
            <DropdownItem>
              <i className="icon_c_m icon_c_bg icon_terms" />
              <FormattedMessage id="header_info_companyTerms" />
            </DropdownItem>
          </Link>
        )}
        {!hide_link_infoserv_serv && (
          <Link to="/info/service" target={all_in_one_tab ? "_self" : "_blank"}>
            <DropdownItem>
              <i className="icon_c_m icon_c_bg icon_settings" />
              <FormattedMessage id="header_info_servicePages" />
            </DropdownItem>
          </Link>
        )}
        {!hide_link_infoserv_faq && (
          <Link to="/info/faq" target={all_in_one_tab ? "_self" : "_blank"}>
            <DropdownItem>
              <i className="icon_c_m icon_c_bg icon_faq" />
              <FormattedMessage id="header_info_FAQ" />
            </DropdownItem>
          </Link>
        )}
        {!hide_link_infoserv_contact && (
          <Link to="/support" target={all_in_one_tab ? "_self" : "_blank"}>
            <DropdownItem>
              <i className="icon_c_m icon_c_bg icon_chats" />
              <FormattedMessage id="header_info_contactChat" />
            </DropdownItem>
          </Link>
        )}
      </DropdownMenu>
    </Dropdown>
  );
};



// WEBPACK FOOTER //
// ./src/components/_Header/_dropdownInfo.js